<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <!-- TABLA DOCUMENTO -->
            <template>
              <div v-if="loading">
                <loading></loading>
              </div>
              <grid-asignacion
                :key="gridDocumento"
                :rowsTable="rowsTable"
              ></grid-asignacion>
              <!-- <v-toolbar card color="white">
              <v-toolbar-title class="indigo--text">En construcción</v-toolbar-title>
            </v-toolbar> -->
            </template>
            <!-- TABLA DOCUMENTO -->
            <template>
              <v-layout row justify-center> </v-layout>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridAsignacion from "@/modules/aplicacion/views/seleccion/asignacion/GridAsignacion.vue";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";

export default {
  name: "asignacion-sub-tab",

  components: {
    GridAsignacion,
    Loading,
    AlertEmpty,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      alerta: true,
      text: "En construccion",
      loading: false,
      proveedor: {},
      rowsTable: [20],
      contratoId: "",
      tabSelect: "",
      activeTab: "",
      index: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      filter: false,
      usuarioLogged: "",
      gridDocumento: 20,
      idEstado: "",
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {
    reloadDocumento() {
      this.gridDocumento += 22;
    },
    selected(tab) {
      this.tabSelect = tab;
    },
    filterDoc() {
      this.filter = true;
    },
  },
};
</script>
